<template>
  <v-menu bottom left>
    <v-btn color="" icon slot="activator" class="ma-0">
      <v-icon style="color:#00000060">more_vert</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile v-if="isAdmin()" @click="edit(item)">
        <v-list-tile-title>Editar</v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="!(item.isFolder == 1) && item.url2.trim() !== ''" @click="download(item)">
        <v-list-tile-title>Descargar</v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="isAdmin() && !isHeritable()" v-show="!item.hidden" @click="hide(item)">
        <v-list-tile-title>Ocultar</v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="isAdmin() && !isHeritable()" v-show="item.hidden" @click="unhide(item)">
        <v-list-tile-title>Mostrar</v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="isAdmin() && !isSearching && !isHeritable()" @click="move(item)">
        <v-list-tile-title>Mover</v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="isAdmin()" @click="drop(item)">
        <v-list-tile-title class="red--text text--darken-2">Eliminar</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import eventBus from '../../utils/eventBus'
import userStorage from '../../storage/userStorage'
import reportsStorage from '../../storage/reportsStorage'

export default {
  name: 'item-menu',
  methods: {
    isAdmin () {
      return userStorage.getUserInfo().userType === 'ADMIN'
    },
    isHeritable () {
      return this.item.heritable
    },
    edit (item) {
      if (item.isFolder) {
        // emit to components/dialogs/folder-form-dialog.vue
        eventBus.$emit('open-folder-form', item)
      } else {
        // emit to components/dialogs/report-form-dialog
        eventBus.$emit('open-report-form', {
          ...item,
          heritable: this.containedBy && this.containedBy.heritable,
          parentName: this.containedBy && this.containedBy.itemName,
          structureID: this.containedBy && this.containedBy.origin
        })
      }
    },
    hide (item) {
      reportsStorage.hideItem(item.itemID)
    },
    unhide (item) {
      reportsStorage.unHideItem(item.itemID)
    },
    move (item) {
      // emit to components/folders/folder-list
      eventBus.$emit('move-item', item)
      // item.isMoving = true
      // window.scrollTo(0, 75)
    },
    drop (item) {
      // emit to components/dialogs/drop-item-dialog.vue
      eventBus.$emit('drop-item', item)
    },
    download (item) {
      window.open(item.url2, '_blank')
      reportsStorage.registerView(item.itemID, 'DOWNLOAD')
    }
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    containedBy: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/menus/item-menu.vue